import mapFunctions from '@/mixins/mapFunctions';

export default {
  transformGeoObject(data) {
    if (data.geoObject) {
      return data.geoObject;
    }
    if (
      data.value_point
      || data.value_linestring
      || data.value_polygon
    ) {
      const geometry = mapFunctions.wktObjectToGeometry(data);
      return {
        data: {
          geometry,
          id: data.geo_object_id,
          properties: {
            country_code: data.country_code,
            road: data.road,
            house_number: data.house_number,
            neighbourhood: data.neighbourhood,
            suburb: data.suburb,
            city_district: data.city_district,
            city: data.city,
            postcode: data.postcode,
            length: data.length,
            start_point: data.start_point,
            end_point: data.end_point,
            area: data.area,
          },
          type: 'Feature',
        },
      };
    }
    return {};
  },
  transformMapObject(data) {
    let { label } = data;
    if (data.mapObjectLabel && data.mapObjectLabel.data && data.mapObjectLabel.data.label) {
      ({ label } = data.mapObjectLabel.data);
    }
    return {
      id: parseInt(data.id, 10),
      parent_id: data.parent_id ? parseInt(data.parent_id, 10) : null,
      relation_id: data.relation_id,
      name: data.name,
      label,
      map_object_type_id: parseInt(data.map_object_type_id, 10),
      geo_object_id: parseInt(data.geo_object_id, 10),
      map_object_status_id: parseInt(data.map_object_status_id, 10),
      is_obstructed: data.is_obstructed,
      created_at: parseInt(data.created_at, 10),
      updated_at: parseInt(data.updated_at, 10),
      deleted_at: data.deleted_at ? parseInt(data.deleted_at, 10) : null,
      created_by: data.created_by ? parseInt(data.created_by, 10) : null,
      attribute: data.attribute ? data.attribute : null,
      geoObject: this.transformGeoObject(data),
      mapObjectLabel: data.mapObjectLabel,
      mapObjectSelection: data.mapObjectSelection,
    };
  },
  transformAction(data) {
    return {
      id: parseInt(data.id, 10),
      map_object_type_id: data.map_object_type_id ? parseInt(data.map_object_type_id, 10) : null,
      action_status_id: parseInt(data.action_status_id, 10),
      map_object_id: data.map_object_id ? parseInt(data.map_object_id, 10) : null,
      geo_object_id: data.geo_object_id ? parseInt(data.geo_object_id, 10) : null,
      dynamic_action_type_id: parseInt(data.dynamic_action_type_id, 10),
      action_priority_id: parseInt(data.action_priority_id, 10),
      created_by: data.created_by ? parseInt(data.created_by, 10) : null,
      created_at: parseInt(data.created_at, 10),
      updated_at: parseInt(data.updated_at, 10),
      deleted_at: data.deleted_at ? parseInt(data.deleted_at, 10) : null,
      external_id: data.external_id,
      external_source_type: data.external_source_type,
      device: data.device,
      network_id: parseInt(data.network_id, 10),
      geoObject: this.transformGeoObject(data),
      attribute: data.attribute ? data.attribute : null,
    };
  },
};
